import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PasswordFormService } from 'src/app/common-components/password-form-control/password-form.service';

import { AccountFinalizationFormValue } from '../models/account-finalization.form';
import { AccountFinalization } from '../models/account-finalization.model';
import * as AccountVerificationActions from '../state/account-verification.actions';
import * as AccountVerificationSelectors from '../state/account-verification.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    providers: [PasswordFormService],
    selector: 'ndt-account-verification',
    templateUrl: './account-verification.component.html',
    standalone: false
})
export class AccountVerificationComponent implements OnDestroy {
   callState$: Observable<CallState>;

   canAccountBeFinalized$: Observable<boolean | null>;

   emailAddress$: Observable<string | null | undefined>;

   form: UntypedFormGroup;

   submitState$: Observable<CallState>;

   userId: number | null;

   private destroyed$ = new Subject<void>();

   constructor(private store: Store<any>) {
      store.pipe(select(AccountVerificationSelectors.selectUserId), takeUntil(this.destroyed$)).subscribe((userId) => {
         this.userId = userId ?? null;
      });

      this.callState$ = store.pipe(select(AccountVerificationSelectors.selectAccountVerificationCallState));
      this.submitState$ = store.pipe(select(AccountVerificationSelectors.selectAccountVerificationSubmitCallState));
      this.canAccountBeFinalized$ = store.pipe(select(AccountVerificationSelectors.selectCanAccountBeFinalized));
      this.emailAddress$ = store.pipe(select(AccountVerificationSelectors.selectAccountVerificationUsername));
      this.store.dispatch(AccountVerificationActions.pageEnter());
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onSubmit(accountFinalizationFormValue: AccountFinalizationFormValue): void {
      if (this.userId) {
         const accountFinalization = this.getAccountFinalization(this.userId, accountFinalizationFormValue);
         this.store.dispatch(
            AccountVerificationActions.savePassword({
               accountFinalization,
            })
         );
      }
   }

   private getAccountFinalization(userId: number, formValue: AccountFinalizationFormValue): AccountFinalization {
      const account: AccountFinalization = {
         confirmPassword: formValue.confirmNewPassword,
         password: formValue.newPassword,
         userId,
      };
      return account;
   }
}
